export default {"src":"/planos/_next/static/media/equifax-portal.d8d66567.svg","height":43,"width":50,"blurWidth":0,"blurHeight":0};